import {
  activeScreenMiddleware,
  bonusCodeMiddleware,
  cashierHostedFieldBridgeMiddleware,
  commonMiddleware,
  communicationTasksMiddleware,
  parentNotificationMiddleware,
  paymentConfirmationMiddleware,
  paymentInfoMiddleware,
  paymentMethodMiddleware,
  paymentProcessingMiddleware,
  platformProcessingInitiatorMiddleware,
} from '@cashier/cashier-common';
import {
  ACCOUNTS_FEATURE_KEY,
  accountsReducer,
  CASHIER_CONFIGURATION_FEATURE_KEY,
  cashierConfigurationReducer,
  CUSTOMER_INFORMATION_KEY,
  customerInformationReducer,
  fetchCertainPaymentMethodEpic,
  fetchDirecta24OptionsEpic,
  fetchDynamicOptionsEpic,
  fetchPaymentCurrentStateEpic,
  fetchPaymentInfoEpic,
  fetchPaymentMethodsEpic,
  FILE_UPLOADING_FEATURE_KEY,
  fileUploadingReducer,
  LEADER_IFRAME_BRIDGE_KEY,
  PAYMENT_CONFIRMATION_FEATURE_KEY,
  PAYMENT_FORM_FEATURE_KEY,
  PAYMENT_METHODS_FEATURE_KEY,
  PAYMENT_PROCESSING_FEATURE_KEY,
  PAYMENT_REGISTRATION_FEATURE_KEY,
  paymentConfirmationEpic,
  paymentConfirmationReducer,
  paymentFormReducer,
  paymentInfoReducer,
  paymentMethodsReducer,
  paymentProcessingEpic,
  paymentProcessingReducer,
  paymentRegistrationEpic,
  paymentRegistrationReducer,
  PAYMENTS_DATA_FEATURE_KEY,
  preprocessorReducer,
  uploadFileEpic,
} from '@cashier/cashier-data-access';
import { createFeature } from '@cashier/cashier-shared';

export const MainAppFeature = createFeature({
  component: {},

  hook: {},

  store: {
    reducerMap: {
      [ACCOUNTS_FEATURE_KEY]: accountsReducer,
      [PAYMENTS_DATA_FEATURE_KEY]: paymentInfoReducer,
      [PAYMENT_FORM_FEATURE_KEY]: paymentFormReducer,
      [CASHIER_CONFIGURATION_FEATURE_KEY]: cashierConfigurationReducer,
      [PAYMENT_METHODS_FEATURE_KEY]: paymentMethodsReducer,
      [PAYMENT_CONFIRMATION_FEATURE_KEY]: paymentConfirmationReducer,
      [PAYMENT_PROCESSING_FEATURE_KEY]: paymentProcessingReducer,
      [PAYMENT_REGISTRATION_FEATURE_KEY]: paymentRegistrationReducer,
      [CUSTOMER_INFORMATION_KEY]: customerInformationReducer,
      [FILE_UPLOADING_FEATURE_KEY]: fileUploadingReducer,
      [LEADER_IFRAME_BRIDGE_KEY]: preprocessorReducer,
    },

    middlewares: [
      commonMiddleware,
      paymentProcessingMiddleware,
      communicationTasksMiddleware,
      paymentMethodMiddleware,
      paymentInfoMiddleware,
      paymentConfirmationMiddleware,
      platformProcessingInitiatorMiddleware,
      activeScreenMiddleware,
      parentNotificationMiddleware,
      bonusCodeMiddleware,
      cashierHostedFieldBridgeMiddleware,
    ],

    epics: [
      paymentConfirmationEpic,
      paymentProcessingEpic,
      paymentRegistrationEpic,
      fetchPaymentInfoEpic,
      fetchDirecta24OptionsEpic,
      fetchCertainPaymentMethodEpic,
      fetchPaymentCurrentStateEpic,
      fetchPaymentMethodsEpic,
      fetchDynamicOptionsEpic,
      uploadFileEpic,
    ],
  },
});
